export default "__VITE_ASSET__nnb$arbU__"